import { Component } from '@angular/core';
import { timer } from 'rxjs/observable/timer';
import { Router } from "@angular/router";
import { Observable } from 'rxjs/Observable';
import {HttpClient} from '@angular/common/http';
import {TranslateService} from '@ngx-translate/core';

//Servicios
import { DefaultService } from '../services/default.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [
    DefaultService
  ]
})
export class AppComponent {
  title = 'iEnrique';
  user:any = {};
  booShowMenu:boolean = false;
  success:boolean = false;
  success2:boolean = false;
  public login:boolean = false;
  public lenguage:string = "";
  
  constructor(
    private http: HttpClient,
    public _defaultService: DefaultService,
    public translate: TranslateService,
    public router: Router
  ){
    this.translate.use('es');
  }

  ngOnInit() {
    this.lenguage = localStorage.getItem('idioma');
    if(this.lenguage == null){
      this.lenguage = 'es';
    }

    this._defaultService.isLogged().subscribe(result => {
      if(result != null && result.emailVerified == true){
        this._defaultService.Data("users", result.uid).subscribe(user => {
          this.user = user;
          this.lenguage = this.user.idioma;

          if(user == undefined){
            this._defaultService.signOut();  
          }else{
            this.http.get<{ip:string}>('https://jsonip.com').subscribe( data => {
              if(this.user.ip != data.ip || this.user.ip == undefined){
                this._defaultService.signOut();
                alert("Hay otro inicio de sesión desde otro dispositivo. Vuelve a iniciar sesión o cambie la contraseña")
              }else{
                this.translate.use(this.user.idioma);
                this.login = true;
              }
            });
          }
        });
      }else{
        this.user = {};
        this.login = false;
        this.router.navigate(['home']);
      }   
    });
  }

  idioma(idioma){
    this.translate.use(idioma);
  }

  showMenu(){
    if(!this.booShowMenu){
      this.booShowMenu = true;
      this.success = true;
      timer(400).subscribe(() => this.success = false);
    }
  }

  showMenu2(){
    if(!this.booShowMenu){
      this.booShowMenu = true;
      this.success = true;
      timer(400).subscribe(() => this.success = false);
    }else{
      this.success2 = true;
      timer(400).subscribe(() => {
        this.success2 = false;
        this.booShowMenu = false;
      });   
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts